import styled, { css } from 'styled-components';

export const Title = styled.h1<{ $isMobile: boolean }>`
  color: var(--black);
  font-style: normal;
  font-weight: 500;

  ${({ $isMobile }) =>
    $isMobile
      ? css`
          min-height: 54px;
          font-size: 22px;
          line-height: 26px; /* 118.182% */
        `
      : css`
          min-height: 50px;
          font-size: 28px;
          line-height: 34px;
        `};
`;
